module.exports = __webpack_public_path__ + "assets/img/filter-demo.22e20dc9.jpg";